let togglerEl = document.querySelector('.js-toggler');
let closeEl = document.querySelector('.js-close-menu');

if(togglerEl) {
  togglerEl.addEventListener('click', (e) => {
    let menuEl = document.querySelector(`#menu`);
    menuEl.classList.add('ox-menu--in-anim');
    document.body.classList.add('ox-u-menu-open');
    setTimeout(function() {
      menuEl.classList.remove('ox-menu--in-anim');
      menuEl.classList.add('ox-menu--active');
    }, 500);
  })
}

if(closeEl) {
  closeEl.addEventListener('click', () => {
    let menuEl = document.querySelector(`#menu`);
    menuEl.classList.remove('ox-menu--active');
    document.body.classList.remove('ox-u-menu-open');
  })
}
